<template>
  <a-space
    class="space-flex"
    :style="{ alignItems: 'flex-start' }"
  >
    <IconFont
      v-if="okrItem.type === 'objective'"
      type="iconmubiao"
      class="icon-block list-objective-icon"
    />
    <KeyResultIcon
      v-else
      class="list-kr-icon"
    />
    <a-space
      direction="vertical"
    >
      <div v-html="okrItem.content" />
      <a-button
        v-if="canEdit"
        type="link"
        :loading="isLoading"
        @click="onCancelAlignment"
      >
        {{ $t('okr.alignedUser.cancelAlignment') }}
      </a-button>
    </a-space>
  </a-space>
</template>

<script>
import { ref } from 'vue'

import { getMyObjective, getMyKeyResult } from '@/graphql/okr'
import { unalign } from '@/api/okr'
import KeyResultIcon from '@/components/KeyResultIcon'

export default {
  name: 'AlignedOkr',
  components: {
    KeyResultIcon
  },
  props: {
    canEdit: {
      type: Boolean,
      required: true
    },
    entity: {
      type: Object,
      required: true
    },
    okrItem: {
      type: Object,
      required: true
    }
  },
  emits: [
    'aligned'
  ],
  setup (props, { emit }) {
    const isLoading = ref(false)

    function getUpdatedEntity (id) {
      const fn = props.entity.type === 'objective' ? getMyObjective : getMyKeyResult
      return fn(id)
    }

    function onCancelAlignment () {
      isLoading.value = true
      unalign(props.entity.statementId, props.okrItem.id)
        .then(() => getUpdatedEntity(props.entity.id))
        .then(updatedEntity => emit('aligned', updatedEntity))
        .finally(() => {
          isLoading.value = false
        })
    }

    return {
      isLoading,
      onCancelAlignment
    }
  }
}
</script>

<style lang="less" scoped>
:deep(.ant-btn-link) {
  height: 24px;
  padding: 0;
}
</style>
